import { api } from '../client'
import { ENDPOINTS } from '../config'
import { ChildRecord, ParentRecord } from '../types'

export interface UpdateParentPayload {
    firstName?: string
    middleName?: string
    lastName?: string
    relationship?: string
    picture?: string
    phoneNumber?: string
    address?: string
    city?: string
    state?: string
    country?: string
    branchId?: string
    [key: string]: unknown
}

export const ParentsService = {
    me: () => api.get<ParentRecord>(ENDPOINTS.PARENTS.ME),

    myChildren: () => api.get<ChildRecord[]>(ENDPOINTS.PARENTS.ME_CHILDREN),

    byName: (name: string) => api.get<ParentRecord[]>(ENDPOINTS.PARENTS.BY_NAME(name)),

    /**
     * A single parent with children, branch and user details resolved.
     *
     * Guarded by `TeacherOrPermsGuard` on the backend, so only teachers and
     * permission holders may call it — a plain parent gets a 403. Parents read
     * their own record through `me()` and anyone else's through `byName()`,
     * which is only `JwtAuthGuard`.
     */
    byId: (id: string) => api.get<ParentRecord>(ENDPOINTS.PARENTS.BY_ID(id)),

    withCoParent: (id: string) =>
        api.get<ParentRecord & { coParent?: ParentRecord | null }>(
            ENDPOINTS.PARENTS.WITH_CO_PARENT(id)
        ),

    updateMe: (payload: UpdateParentPayload) =>
        api.patch<ParentRecord>(ENDPOINTS.PARENTS.UPDATE_ME, payload),

    requestTeacherRole: () => api.post<unknown>(ENDPOINTS.PARENTS.REQUEST_TEACHER_ROLE),

    requestParentRole: () => api.post<unknown>(ENDPOINTS.PARENTS.REQUEST_PARENT_ROLE)
}
